import WebApp from '@twa-dev/sdk';

import { isDesktop } from '@/shared/helpers/environment/is-desktop';
import { getAndroidInfo } from '@/shared/helpers/get-android-info';

(function () {
  /*
   * Initialize Telegram Web App SDK
   * After start initial params webapp libs.
   */

  try {
    WebApp.ready();
    WebApp.expand();

    const isDesktopPlatform = isDesktop();
    const androidInfo = getAndroidInfo();

    const isAndroidVersionLt11 =
      !!androidInfo?.majorAndroidVersion && androidInfo.majorAndroidVersion < 11;

    const disableFullscreen = isAndroidVersionLt11 || isDesktopPlatform;

    if (!isDesktopPlatform) {
      if ('requestFullscreen' in WebApp && !disableFullscreen) {
        WebApp.requestFullscreen();
      }

      const isPortrait = window.innerWidth < window.innerHeight;

      if ('lockOrientation' in WebApp && isPortrait) {
        WebApp.lockOrientation();
      }

      if ('disableVerticalSwipes' in WebApp) {
        WebApp.disableVerticalSwipes();
      }
    }
  } catch (error) {
    console.error('Error while initializing Telegram Web App features:', error);
  }
})();
